import {useMemo} from 'react'
import {Empty, Space, Table, Typography} from 'antd'
import {CheckCircleFilled, CheckCircleOutlined, DeleteOutlined} from '@ant-design/icons'
import EllipsisTooltip from '../../common/EllipsisTooltip'
import RecordsCount from '../../common/RecordsCount'
import TableActions from '../../common/TableActions'
import {useIntl} from 'react-intl'

const InspectionPointsTable = ({
  dataSource,
  pagination = false,
  getInspectionPointsData = null,
  onDelete = null,
}) => {
  const intl = useIntl()

  const columns = useMemo(
    () => [
      {
        title: intl.formatMessage({ id: 'inspectionPoints.connectorName' }),
        dataIndex: 'connector_name',
        width: 200,
        sorter: (a, b) => (a.connector_name || '').localeCompare(b.connector_name || ''),
        render: (text) => (
          <EllipsisTooltip className="ellipsis">
            {text || '-'}
          </EllipsisTooltip>
        ),
      },
      {
        title: intl.formatMessage({ id: 'inspectionPoints.inspectionPointId' }),
        dataIndex: 'inspection_points_display',
        render: (text) => (
          <EllipsisTooltip className="ellipsis">
            {text || '-'}
          </EllipsisTooltip>
        ),
      },
      {
        title: intl.formatMessage({ id: 'inspectionPoints.harness' }),
        dataIndex: 'harness_display',
        sorter: (a, b) => (a.harness_display || '').localeCompare(b.harness_display || ''),
        render: (text) => (
          <EllipsisTooltip className="ellipsis">
            {text || '-'}
          </EllipsisTooltip>
        ),
      },
      {
        title: intl.formatMessage({ id: 'inspectionPoints.action' }),
        align: 'right',
        width: 136,
        render: (_, record) => (
          <Space size="small">
            {record.wires_generated && (
              <CheckCircleFilled
                style={{ color: 'var(--color-sucess-icon)' }}
                title={intl.formatMessage({ id: 'inspectionPoints.wiresGenerated' })}
              />
            )}
            <TableActions
              actions={[
                { key: 'delete', label: intl.formatMessage({ id: 'forms.delete' }), icon: <DeleteOutlined />, danger: true, onClick: () => onDelete(record) },
              ]}
            />
          </Space>
        ),
      },
    ],
    [dataSource, pagination]
  )

  return (
    <Space
      direction="vertical"
      size="middle"
      style={{ width: '100%', verticalAlign: 'top' }}
    >
      <Table
        rowKey={(record) => `inspection-point-${record.id}`}
        columns={columns}
        dataSource={dataSource}
        showSorterTooltip={false}
        tableLayout='fixed'
        scroll={{
          x: dataSource.length > 0 ? 760 : undefined
        }}
        pagination={
          pagination
            ? {
                current: pagination?.currentPage,
                total: pagination?.totalCount,
                pageSize: 10,
                showSizeChanger: false,
                hideOnSinglePage: true,
                showTotal: (total) => <RecordsCount count={total} />,
                onChange: (page) => {
                  const offset = (page - 1) * 10
                  const url = pagination?.nextPageLink
                    ? new URL(pagination?.nextPageLink)
                    : new URL(pagination?.prevPageLink)
                  url.searchParams.set('offset', offset)
                  getInspectionPointsData(url.toString())
                },
              }
            : false
        }
        locale={{
          emptyText: (
            <div style={{ padding: '40px' }}>
              <Empty description={<RecordsCount count={0} />} />
            </div>
          ),
        }}
      />
      {pagination && pagination?.totalPages <= 1 && pagination?.totalCount > 0 && (
        <Typography.Text>
          <RecordsCount count={pagination?.totalCount} />
        </Typography.Text>
      )}
    </Space>
  )
}

export default InspectionPointsTable
